module.exports = __webpack_public_path__ + "static/img/service-3.6104750d.jpg";